import { makeStyles } from "@fluentui/react-components";

export const useReportParamsViewStyles = makeStyles({
  spinnerContainer: {
    position: "fixed",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    zIndex: 1000,
    backgroundColor: "rgba(0, 0, 0, 0.4)",
    width: "100vw",
    height: "100vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "24px",
    boxSizing: "border-box",
  },
  loadingOverlayContent: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: "12px",
    maxWidth: "340px",
  },
  loadingStatus: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "16px",
  },
  loadingText: {
    color: "#ffffff",
    fontWeight: 600,
  },
  loadingActions: {
    display: "flex",
    justifyContent: "center",
  },
  longRunningDataLoadNotice: {
    maxWidth: "320px",
    padding: "12px 14px",
    border: "1px solid #E0A500",
    borderRadius: "6px",
    backgroundColor: "#ffffff",
    color: "#242424",
    boxShadow: "0 8px 24px rgba(0, 0, 0, 0.18)",
    lineHeight: 1.35,
  },
  longRunningDataLoadNoticeTitle: {
    marginBottom: "4px",
    color: "#001C71",
    fontWeight: 600,
  },
  longRunningDataLoadNoticeText: {
    margin: 0,
  },
  parameter: {
    paddingBottom: "8px",
  },
  parameterLabel: {
    display: "inline-block",
    minWidth: "100px",
    color: "#001C71",
  },
  parameterRequiredMarker: {
    color: "#C85A00",
    fontWeight: 700,
    marginLeft: "3px",
  },
  parameterWarning: {
    color: "red",
  },
  parameterControl: {
    fontSize: "inherit",
    width: "280px",
    overflow: "hidden",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
    border: "0.25pt solid #C4E1E0",
    borderRadius: "6px",
    "&:hover": {
      border: "0.25pt solid #7FBDBA",
    },
    "&:disabled": {
      border: "0.25pt solid #E0E0E0",
      backgroundColor: "#F5F5F5",
      color: "#A0A0A0",
      opacity: 0.6,
      cursor: "not-allowed",
    },
  },
  commandArea: {
    paddingTop: "8px",
  },
  saveCommandArea: {
    marginTop: "16px",
    marginLeft: "-20px",
    marginRight: "-20px",
    borderTop: "0.25pt solid #E0E0E0",
    paddingTop: "16px",
    paddingLeft: "20px",
    paddingRight: "20px",
    display: "flex",
    gap: "8px",
  },
  button: {
    minWidth: "265px",
    paddingTop: "3px",
    paddingBottom: "3px",
    paddingLeft: "20px",
    paddingRight: "20px",
    border: "0.25pt solid #7FBDBA",
    backgroundColor: "#001C71",
    color: "#ffffff",
    fontWeight: "bold",
    "&:hover": {
      border: "0.25pt solid #001C71",
      backgroundColor: "#001C71",
      color: "#ffffff",
    },
    "&:disabled": {
      border: "0.25pt solid #E0E0E0",
      backgroundColor: "#F5F5F5",
      color: "#A0A0A0",
      opacity: 0.6,
      cursor: "not-allowed",
    },
  },
  cancelButton: {
    minWidth: "100px",
    paddingTop: "3px",
    paddingBottom: "3px",
    paddingLeft: "12px",
    paddingRight: "12px",
    border: "0.25pt solid #E0A500",
    backgroundColor: "#C85A00",
    color: "#ffffff",
    fontWeight: "bold",
    "&:hover": {
      backgroundColor: "#b94900",
    },
    "&:disabled": {
      border: "0.25pt solid #E0E0E0",
      backgroundColor: "#F5F5F5",
      color: "#A0A0A0",
      opacity: 0.6,
      cursor: "not-allowed",
    },
  },
  wideButton: {
    minWidth: "280px",
    paddingTop: "3px",
    paddingBottom: "3px",
    paddingLeft: "20px",
    paddingRight: "20px",
    border: "0.25pt solid #7FBDBA",
    backgroundColor: "#001C71",
    color: "#ffffff",
    fontWeight: "bold",
    "&:hover": {
      border: "0.25pt solid #001C71",
      backgroundColor: "#001C71",
      color: "#ffffff",
    },
    "&:disabled": {
      border: "0.25pt solid #E0E0E0",
      backgroundColor: "#F5F5F5",
      color: "#A0A0A0",
      opacity: 0.6,
      cursor: "not-allowed",
    },
  },
  saveButton: {
    width: "90px",
    paddingLeft: "20px",
    paddingRight: "20px",
    border: "0.25pt solid #7FBDBA",
    backgroundColor: "#001C71",
    color: "#ffffff",
    fontWeight: "bold",
    "&:hover": {
      border: "0.25pt solid #001C71",
      backgroundColor: "#001C71",
      color: "#ffffff",
    },
    "&:disabled": {
      border: "0.25pt solid #E0E0E0",
      backgroundColor: "#F5F5F5",
      color: "#A0A0A0",
      opacity: 0.6,
      cursor: "not-allowed",
    },
  },
  dropDownButton: {
    borderRadius: "6px",
    border: "0.25pt solid #C4E1E0",
    backgroundColor: "#001C71",
    color: "#ffffff",
    fontSize: "11px",
    display: "block",
    "&:hover": {
      border: "0.25pt solid #C4E1E0",
      backgroundColor: "#001C71",
      color: "#ffffff",
    },
    "&:disabled": {
      border: "0.25pt solid #E0E0E0",
      backgroundColor: "#F5F5F5",
      color: "#A0A0A0",
      opacity: 0.6,
      cursor: "not-allowed",
    },
  },
});

export type ReportParamsViewStyles = ReturnType<typeof useReportParamsViewStyles>;
